<template>
  <div>
    <base-header :type="gradientType" class="pb-6 pb-8 pt-5 pt-md-8">
      <base-dropdown v-if="activeModules.length > 1">
        <base-button slot="title" :type="buttonType" class="dropdown-toggle">
          {{ _.startCase(currentProfile) }}
        </base-button>
        <a
          v-for="profile in activeModules"
          :key="profile.id"
          @click.prevent="
            setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)
          "
          class="dropdown-item"
          href="#"
          >{{ profile.name }}</a
        >
      </base-dropdown>
      <!-- <base-dropdown v-else>
               <base-button slot="title" type="primary" class="dropdown-toggle">
                 Customer Profiles
               </base-button> 
               <a class="dropdown-item" disabled>No active module/s under this feature</a>
            </base-dropdown> -->
      <!-- <base-dropdown >
                <base-button slot="title" type="success" class="dropdown-toggle">
                    Customer Profiles - {{_.startCase(currentProfile)}}
                </base-button>
                    <a @click.prevent="setCurrentProfile('customers')" class="dropdown-item" href="#">Customer</a>
                    <a @click.prevent="setCurrentProfile('customer_types')" class="dropdown-item" href="#">Customer Type</a>
                    <a @click.prevent="setCurrentProfile('customer_card_types')" class="dropdown-item" href="#">Customer Card Type</a>
            </base-dropdown> -->
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card mb-3">
            <div class="row no-gutters">
              <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                  <filter-bar @changeFilter="changeFilter" :key="statusKey"></filter-bar>
                </div>
              </div>

              <div class="col-md-9">
                <div class="card-body">
                  <profiles-table
                    :status="filterStatus"
                    :key="formKey"
                    :accessRights="accessRights"
                  ></profiles-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTPRequest from "../../controllers/httpRequest.js";
import ProfilesTable from "../Tables/DiscountsTable.vue";
import FilterBar from "./../FilterBar";
import { mapState, mapActions } from "vuex";
import secureStorage from "../../controllers/secureStorage";

export default {
  data() {
    return {
      formKey: 0,
      activeModules: [],
      accessRights: [],
      gradientType: "instore",
      buttonType: "success",
      statusKey: 0,
      filterStatus: "",
    };
  },
  watch: {
    $route: async function (to, from) {
      await this.loadPage();
    },
  },

  async mounted() {
    this.loadPage();
  },
  computed: {
    ...mapState(["currentProfile", "currentApiURL", "endPoint", "parameters"]),
  },
  components: {
    ProfilesTable,
    FilterBar,
  },
  methods: {
    ...mapActions(["updateCurrentProfile", "updateParameters"]),
    async loadPage() {
      var categoryId
      var providedFilter = this.$route.query.type;
      console.log("providedFilter", providedFilter)
      // if (providedFilter.includes("DM-"))
        categoryId = await HTTPRequest.getRequest(
          this.endPoint + "/system_module_categories?code=MDM-005",
          null,
          null
        );
      // else
      //   categoryId = await HTTPRequest.getRequest(
      //     this.endPoint + "/system_module_categories?code=MCS-002",
      //     null,
      //     null
      //   );

      // var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=MDM-003', null, null)
      this.activeModules = await HTTPRequest.getRequest(
        this.endPoint +
          "/system_module_categories/" +
          categoryId[0].id +
          "/enabled_modules",
        null,
        null
      );
      if (this.activeModules.length > 0) {
        var profile = _.snakeCase(this.activeModules[0].name);
        this.setCurrentProfile(_.pluralize(profile), this.activeModules[0].id);
      } else {
        this.setCurrentProfile(null, null);
        this.formKey++;
      }

      if (providedFilter.includes("CA-")) {
        this.gradientType = "instore";
        this.buttonType = "success";
      } else {
        this.gradientType = "instore";
        this.buttonType = "success";
      }
    },
    async setCurrentProfile(profile, id) {
      this.profileId = id;
      var accessRightsRequest = await HTTPRequest.getRequest(
        this.endPoint +
          "users/" +
          secureStorage.getItem("userId") +
          "/access_rights?system_module_id=" +
          id,
        null
      );
      if (_.isEmpty(accessRightsRequest.access_rights) == false) {
        this.accessRights = accessRightsRequest.access_rights[id];
      } else {
        this.accessRights = [];
      }
      this.updateCurrentProfile(profile);
      this.statusKey++;
      this.formKey++;
    },
    changeFilter(statusFilter, searchFilter, searchText) {
      this.filterStatus = statusFilter;
      if (statusFilter == "0") {
        this.updateParameters("?" + searchFilter + "=" + searchText);
      } else if (statusFilter == "A") {
        this.updateParameters("?" + searchFilter + "=" + searchText + "&status=A");
      } else {
        this.updateParameters("?" + searchFilter + "=" + searchText + "&status=I");
      }
    },
  },
};
</script>
